<script>
import http from '../api/http.js'
import router from '../router'
import jwt_decode from "jwt-decode";
import { Button, Form, FormItem, Input, Message } from 'element-ui'
function openJdReadBook(id, bookId, terminal, page, callback){
  if (!id) {
    return;
  }
  if (!window.localStorage.Token || window.localStorage.Token.length < 128) {
    window.location.href = "/login?redirect=/detail/dzDetail/" + id;
    return;
  }
  http.api.GetJdReadBook({id: id, page: page ? page : "", TERMINALTYPE: terminal, ebookid: bookId}).then((res) => {
    if (res.code != 1) {
      Message({message: "看书失败!", type: "error"});
      return; 
    }
    if(callback){
      callback(res);
      return;
    }
    window.open(res.data);
  });
}
function browse(SOURCEID, BUSINESSTYPE, callback) {
  if (!SOURCEID) {
    return;
  }
  http.api.Browse({
    SOURCEID: SOURCEID,
    BUSINESSTYPE: BUSINESSTYPE,
    TERMINALTYPE: 2, //1(手机端)，2(电脑端)
    ORGID: getMember().orgId
  }).then((res) => {
    if (callback) {
      callback(res);
    }
  });
}
function getProductUrl(id, type) {
  if (type == "2") {
    return "/detail/ysDetail/" + id;
  }
  if (type == "3") {
    return "/detail/qkDetail/" + id;
  }
  return "/detail/dzDetail/" + id;
}
function openProductUrl(id, type) {
  window.open(this.getProductUrl(id, type), '_blank');
}
function addCollect(val) {
  if (!isLogin()) {
      window.location.href = "/login?redirect=" + window.location.pathname;
      return;
  }
  var params = {
    BUSINESSTYPE: val.ProductType,
    COLLECTOBJECTID: val.Id,
    ISDELETED: val.IsCollect ? 1 : 0,
  };
  http.api.SubmitCollect(params).then((res) => {
    Message({
      message: res.data,
      type: res.code == 1 ? "success" : "warning",
    });
    if (res.code != 1) {
      return;
    }
    val.IsCollect = !val.IsCollect;
  });
}
function getMember(){
  var member = window.localStorage.Token ? jwt_decode(window.localStorage.Token) : undefined;
  if(!member) {
    var org = http.GetOrgInfo();
    member = {
      orgId: org ? org.OrgId : "",
      schoolId: org ? org.Id : "",
    };
  }
  return member;
}
function isLogin(){
  if (getMember().userKey) {
      return true;
  }
  return false
}
function openError(msg) {
  router.push({name: 'error', params: { message: msg }});
}
function delHtmlTag (str) {
  if(!str){
    return '';
  }
  return str.replace(/<[^>]+>|\s*/g, '');
}
export default {
  browse,
  getProductUrl,
  openProductUrl,
  addCollect,
  getMember,
  openError,
  openJdReadBook,
  isLogin,
  delHtmlTag
};
</script>



// WEBPACK FOOTER //
// src/common/GlobalMethod.vue